<template>
  <div class="supplierDetail">
    <div class="topBar">
      <div class="title">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"
        ></i>供应商详情
      </div>
    </div>
    <div class="mainBody">
      <div class="title">
        <div style="margin-left:10px">供应商详情</div>
        <div>
          <router-link :to="'/admin/supplierEdit/'+id">
              <el-button plain class="edit">编辑</el-button>
          </router-link>
        </div>
      </div>
      <div class="table">
        <div class="row">
          <el-row>
            <el-col :span="4">供应商名称:</el-col>
            <el-col :span="20">{{tableData.name}}</el-col>
          </el-row>
        </div>
        <div class="row">
          <el-row>
            <el-col  :span="3">供应商类型:</el-col>
            <el-col  :span="8">{{tableData.type}}</el-col>
            <el-col  :span="3">付款方式:</el-col>
            <el-col  :span="8">{{tableData.payType}}</el-col>
          </el-row>
        </div>
        <div class="row">
          <el-row>
            <el-col :span="3">采购员:</el-col>
            <el-col :span="8">{{tableData.buyer}}</el-col>
            <el-col :span="3">电话:</el-col>
            <el-col :span="8">{{tableData.phone?tableData.phone:'暂无信息'}}</el-col>
          </el-row>
        </div>
        <div class="row">
          <el-row>
            <el-col :span="3">所在国家:</el-col>
            <el-col :span="8">{{tableData.country?tableData.country:'暂无信息'}}</el-col>
            <el-col :span="3">所在省份:</el-col>
            <el-col :span="8">{{tableData.province?tableData.province:'暂无信息'}}</el-col>
          </el-row>
        </div>
        <div class="row">
          <el-row>
            <el-col :span="3">所在市:</el-col>
            <el-col :span="8">{{tableData.city?tableData.city:'暂无信息'}}</el-col>
            <el-col :span="3">具体地址:</el-col>
            <el-col :span="8">{{tableData.address?tableData.address:'暂无信息'}}</el-col>
          </el-row>
        </div>
        <div class="row">
          <el-row>
            <el-col :span="3">网址:</el-col>
            <el-col :span="8">{{tableData.URL?tableData.URL:'暂无信息'}}</el-col>
            <el-col :span="3">开户行:</el-col>
            <el-col :span="8">{{tableData.openingBank?tableData.openingBank:'暂无信息'}}</el-col>
          </el-row>
        </div>
        <div class="row">
          <el-row>
            <el-col :span="3">邮政编码:</el-col>
            <el-col :span="8">{{tableData.postCode?tableData.postCode:'暂无信息'}}</el-col>
            <el-col :span="3">税号:</el-col>
            <el-col :span="8">{{tableData.dutyCode?tableData.dutyCode:'暂无信息'}}</el-col>
          </el-row>
        </div>
        <div class="row">
          <el-row>
            <el-col :span="3">法定代表人:</el-col>
            <el-col :span="8">{{tableData.legalPerson?tableData.legalPerson:'暂无信息'}}</el-col>
            <el-col :span="3">委托代理人:</el-col>
            <el-col :span="8">{{tableData.agent?tableData.agent:'暂无信息'}}</el-col>
          </el-row>
        </div>
        <div class="row">
          <el-row>
            <el-col :span="3">共享人:</el-col>
            <el-col :span="8">{{tableData.sharePerson?tableData.sharePerson:'暂无信息'}}</el-col>
            <el-col :span="3">预设价格:</el-col>
            <el-col :span="8">{{tableData.presetPrice?tableData.presetPrice:'暂无信息'}}</el-col>
          </el-row>
        </div>
        <div class="row">
          <el-row>
            <el-col :span="3">单位抬头:</el-col>
            <el-col :span="8">{{tableData.companyHead?tableData.companyHead:'暂无信息'}}</el-col>
            <el-col :span="3">发票类型:</el-col>
            <el-col :span="8">{{tableData.invoiceType?tableData.invoiceType:'暂无信息'}}</el-col>
          </el-row>
        </div>
        <div class="row">
          <el-row>
            <el-col :span="3">税率:</el-col>
            <el-col :span="8">{{tableData.taxRate?tableData.taxRate + '%':'暂无信息'}}</el-col>
            <el-col :span="3">对应客户:</el-col>
            <el-col :span="8">{{tableData.client?tableData.client:'暂无信息'}}</el-col>
          </el-row>
        </div>
        <div class="row">
          <el-row>
            <el-col :span="3">经营范围:</el-col>
            <el-col :span="8">{{tableData.businessScope?tableData.businessScope:'暂无信息'}}</el-col>
          </el-row>
        </div>
        <div class="row">
          <el-row>
            <el-col :span="3">备注:</el-col>
            <el-col :span="8">{{tableData.remark?tableData.remark:'暂无信息'}}</el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'supplierDetail',
  data() {
    return { serve: this.$store.state.serve,
      serve: this.$store.state.serve,
      username: this.$cookies.get('username'),
      token: this.$cookies.get('token'),
      tableData: '',
      id:''
    }
  },
  created() {
    this.$store.state.topActiveId = 2
    this.$store.state.leftTitle = '供应商管理'
    this.getting()
  },
  methods: {
    getting() {
      var id = this.$route.params.id
      this.id = id
      if (!id) {
        this.$message({
          showClose: true,
          message: '供应商信息不存在',
          type: 'error',
          offset: 300
        })
        this.$router.go(-1)
      }
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.axios
        .get(this.serve + '/admin/supplierDetail', {
          params: {
            username: this.username,
            token: this.token,
            id: id
          }
        })
        .then(res => {
          let data = res.data
          if (data.status == 'success') {
            this.tableData = data.data
            loading.close();
          } else {
            loading.close();
            this.$message({
              showClose: true,
              message: '供应商信息不存在',
              type: 'error',
              offset: 300
            })
            this.$router.go(-1)
          }
        })
    }
  }
}
</script>

<style lang="scss">
.supplierDetail {
  background: #f5f5f5;
  color: #333;
  min-height: 1100px;
  .topBar {
    margin-bottom: 40px;
    .title {
      width: 1056px;
      margin: 0 auto;
      font-size: 14px;
    }
  }
  .mainBody {
    width: 1056px;
    margin: 0 auto;
    .title {
      background-color: #eee;
      border: 1px solid #ddd;
      height: 46px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .edit {
        margin-right: 20px;
      }
      .edit:hover {
        color: white;
        background-color: #0099ff;
      }
    }
    .table {
      border: 1px solid #ddd;
      background-color: white;
      padding: 20px;
      .row {
        margin-bottom: 20px;
      }
    }
  }
}
</style>